import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import { theme } from "styles";
import { useNavigate, useLocation } from "react-router";
import { useDispatch } from "react-redux";

import Button from "components/entrance/Button";
import Text from "components/ui/Text";
import { CenterListCard } from "components/all/settings";
import CheckBlue from "assets/icons/icon_check_blue.svg";
import { updatePartnerInfo } from "redux/slices/partner/partnerSlice";

const getPartnerLength = (partners) => {
  let len = 0;
  for (let i = 0; i < partners.length; i++) {
    if (partners[i].partnerBranches.length) {
      len = len + partners[i].partnerBranches.length;
    } else {
      len++;
    }
  }
  return len;
};

const SignupDone = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { name, partners } = location.state;
  const partnerLength = getPartnerLength(partners);

  useEffect(() => {
    dispatch(updatePartnerInfo());
  }, []);

  return (
    <Wrapper>
      <WrapperTop>
        <img src={CheckBlue} alt="checkBlue" />
        <Text
          color="primary100"
          fontSize="24px"
          fontWeight="700"
          lineHeight="30px"
        >
          회원가입 완료
        </Text>
        <TextBoxMiddle>
          <Text
            display="block"
            color="primary100"
            fontSize="22px"
            fontWeight="600"
            lineHeight="32px"
          >
            {name}님 가입이 완료되었습니다
          </Text>
          <Text fontSize="18px" lineHeight="28px">
            센터관리를 시작해볼까요?
          </Text>
        </TextBoxMiddle>
      </WrapperTop>

      <WrapperBtm>
        <div>
          <Text
            fontWeight="600"
            lineHeight="24px"
            css={css`
              margin-right: 6px;
            `}
          >
            연동 센터
          </Text>
          <Text color="primary50" fontWeight="700" lineHeight="24px">
            {partnerLength}개
          </Text>
          <ListBox>
            <CenterListCard
              partnerInfo={{
                partnerList: partners,
              }}
              isSetting={false}
            />
          </ListBox>
        </div>

        <Button onClick={() => navigate("/home")}>시작하기</Button>
      </WrapperBtm>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 20px 20px 42px;
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const WrapperTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 124px;
  img {
    width: 24px;
    height: 16px;
    margin-bottom: 16px;
  }
`;
const TextBoxMiddle = styled.div`
  text-align: center;
  margin-top: 64px;
`;

const WrapperBtm = styled.div`
  button {
    margin-top: 24px;
  }
`;
const ListBox = styled.div`
  margin-top: 13px;
  padding: 8px 16px;
  border: 1px solid ${theme.colors["line20"]};
  height: 240px;
  overflow-x: hidden;
  overflow-y: scroll;
  border-radius: 12px;
`;

export default SignupDone;
